export async function fetchRemoveLastOrderId() {
  window.localStorage.removeItem('lastOrderId')
  return null
}
